__turbopack_context__.v({
  "className": "ibm_plex_sans_1642a9e4-module___bGOcW__className",
});
